import { configureStore } from '@reduxjs/toolkit';
import authSlice from './auth-slice';
import webViewSlice from './webview';
import dealSlice from './deal-slice';

const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        webView: webViewSlice.reducer,
        deals: dealSlice.reducer
    }
});

export default store;
